export default "__VITE_ASSET__C5N4CM5u__"